"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createImageAvatarStyle;
function createImageAvatarStyle(_ref) {
  var avatarSize = _ref.avatarSize;
  return {
    height: avatarSize,
    overflow: 'hidden',
    width: avatarSize
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJjcmVhdGVJbWFnZUF2YXRhclN0eWxlIiwiX3JlZiIsImF2YXRhclNpemUiLCJoZWlnaHQiLCJvdmVyZmxvdyIsIndpZHRoIl0sInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvU3R5bGVzL1N0eWxlU2V0L0ltYWdlQXZhdGFyLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IFN0cmljdFN0eWxlT3B0aW9ucyB9IGZyb20gJ2JvdGZyYW1ld29yay13ZWJjaGF0LWFwaSc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIGNyZWF0ZUltYWdlQXZhdGFyU3R5bGUoeyBhdmF0YXJTaXplIH06IFN0cmljdFN0eWxlT3B0aW9ucykge1xuICByZXR1cm4ge1xuICAgIGhlaWdodDogYXZhdGFyU2l6ZSxcbiAgICBvdmVyZmxvdzogJ2hpZGRlbicsXG4gICAgd2lkdGg6IGF2YXRhclNpemVcbiAgfTtcbn1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBRWUsU0FBU0Esc0JBQXNCQSxDQUFBQyxJQUFBLEVBQXFDO0VBQUEsSUFBbENDLFVBQVUsR0FBQUQsSUFBQSxDQUFWQyxVQUFVO0VBQ3pELE9BQU87SUFDTEMsTUFBTSxFQUFFRCxVQUFVO0lBQ2xCRSxRQUFRLEVBQUUsUUFBUTtJQUNsQkMsS0FBSyxFQUFFSDtFQUNULENBQUM7QUFDSCJ9